import React from 'react'

export default class GenericDomain extends React.Component {
    render() {
        let color = '#595C61'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='32'
                height='32'
                viewBox='0 0 32 32'
                fill='none'
            >
                <rect width='32' height='32' rx='12' fill='#E5E9EE' />
                <path
                    d='M16 24.3333C20.6024 24.3333 24.3334 20.6023 24.3334 16C24.3334 11.3976 20.6024 7.66663 16 7.66663C11.3976 7.66663 7.66669 11.3976 7.66669 16C7.66669 20.6023 11.3976 24.3333 16 24.3333Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M16 7.66663C13.8602 9.91342 12.6667 12.8972 12.6667 16C12.6667 19.1027 13.8602 22.0865 16 24.3333C18.1398 22.0865 19.3334 19.1027 19.3334 16C19.3334 12.8972 18.1398 9.91342 16 7.66663Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.66669 16H24.3334'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
